import type { CallToActionModel } from '~~/app/models'

export const useCtaTarget = (cta: CallToActionModel) => {
  return cta?.elements?.linked_target?.value?.length > 0 ? '_self' : '_blank'
}

export function targetName(cta: CallToActionModel, customTarget?: string) {
  return customTarget ? customTarget : useCtaTarget(cta)
}
